import { Module, ModuleWithProviders } from '@rxdi/core';

import { TranslationsConfig } from './translate.config';
import { TranslateService } from './translate.service';
import { TranslateComponent } from './translate-dropdown.component';

@Module({
  components: [TranslateComponent],
  providers: [TranslateService, { provide: TranslationsConfig, useValue: {} }],
})
export class TranslationsModule {
  public static forRoot(config: TranslationsConfig): ModuleWithProviders {
    return {
      module: TranslationsModule,
      providers: [
        {
          provide: TranslationsConfig,
          useFactory: () => ({
            ...config,
            languages: config.languages || Object.keys(config.translations),
          }),
        },
      ],
    };
  }
}
